import { ILongSteelOrderItem } from '../long-steel-shopping-cart/types';

// Action Types
export enum Types {
  SEARCH_ITEM = 'longSteelOrderItemSearch/SEARCH_ITEM',
  SEARCH_ITEM_SUCCESS = 'longSteelOrderItemSearch/SEARCH_ITEM_SUCCESS',
  SEARCH_ITEM_FAILURE = 'longSteelOrderItemSearch/SEARCH_ITEM_FAILURE',

  FACELIFT_SEARCH_ITEM = 'longSteelOrderItemSearch/FACELIFT_SEARCH_ITEM',
  FACELIFT_SEARCH_ITEM_SUCCESS = 'longSteelOrderItemSearch/FACELIFT_SEARCH_ITEM_SUCCESS',
  FACELIFT_SEARCH_ITEM_FAILURE = 'longSteelOrderItemSearch/FACELIFT_SEARCH_ITEM_FAILURE',

  SEARCH_ITEM_SPREADSHEET = 'longSteelOrderItemSearch/SEARCH_ITEM_SPREADSHEET',
  SEARCH_ITEM_SPREADSHEET_SUCCESS = 'longSteelOrderItemSearch/SEARCH_ITEM_SPREADSHEET_SUCCESS',
  SEARCH_ITEM_SPREADSHEET_FAILURE = 'longSteelOrderItemSearch/SEARCH_ITEM_SPREADSHEET_FAILURE',
  SPREADSHEET_ITEMS_EXCEEDED = 'longSteelOrderItemSearch/SPREADSHEET_ITEMS_EXCEEDED',

  SEARCH_ITEM_SPREADSHEET_MVP = 'longSteelOrderItemSearch/SEARCH_ITEM_SPREADSHEET_MVP',
  CLEAN_ITEM_SPREADSHEET_MVP = 'longSteelOrderItemSearch/CLEAN_ITEM_SPREADSHEET_MVP',

  LOAD_LAST_ORDERS = 'longSteelOrderItemSearch/LOAD_LAST_ORDERS',
  LOAD_LAST_ORDERS_SUCCESS = 'longSteelOrderItemSearch/LOAD_LAST_ORDERS_SUCCESS',
  LOAD_LAST_ORDERS_FAILURE = 'longSteelOrderItemSearch/LOAD_LAST_ORDERS_FAILURE',
  CLEAN_LAST_ORDERS = 'longSteelOrderItemSearch/CLEAN_LAST_ORDERS',

  SEARCH_ITEMS_FROM_LAST_ORDER = 'longSteelOrderItemSearch/SEARCH_ITEMS_FROM_LAST_ORDER',
  SEARCH_ITEMS_FROM_LAST_ORDER_SUCCESS = 'longSteelOrderItemSearch/SEARCH_ITEMS_FROM_LAST_ORDER_SUCCESS',
  SEARCH_ITEMS_FROM_LAST_ORDER_FAILURE = 'longSteelOrderItemSearch/SEARCH_ITEMS_FROM_LAST_ORDER_FAILURE',

  REMOVE_SEARCHED_ITEM = 'longSteelOrderItemSearch/REMOVE_SEARCHED_ITEM',
  ADD_SEARCHED_ITEM = 'longSteelOrderItemSearch/ADD_SEARCHED_ITEM',

  CLEAN_ERRORS = 'longSteelOrderItemSearch/CLEAN_ERRORS'
}

export const SPREADSHEET_PRODUCT_NOT_FOUND = 'Produto não identificado';

export interface ILongSteelOrderItemSearchState {
  searchedItems: ILongSteelOrderItem[];
  searchingItems: boolean;

  searchingItemsError: boolean;
  searchingItemsSpreadsheetError: boolean;
  searchingItemsLastOrderError: boolean;
  searchingItemsSpreadsheetItemsExceeded: boolean;

  lastOrdersState: ILastOrdersState;
}

export interface ILastOrdersState {
  loading: boolean;
  error: boolean;

  customerId: string;
  lastOrders: ILastOrder[];
  selectedLastOrder?: ILastOrder;
}

export interface ILastOrder {
  customerSoldTo: string;
  customerShipTo: string;
  customerPurchaseOrder: string;
  salesOrder: string;
  orderDate: string;
  items: ILastOrderItem[];
}

export interface ILastOrderItem {
  customerOrder: string;
  customerProduct: string;
  division: string;
  divisionDescription: string;
  materialDescription: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  product: string;
  requestedMeasureUnit: string;
  requestedQuantity: number;
  salesOrderItem: string;
}
